module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png",
      "alt": "LeadScorz",
      "title": "LeadScorz"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-4 col-sm-offset-4"
  }, [_c('form', {
    staticClass: "ui form loginForm",
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Thank you! Please check your email for further instructions.")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.error),
      expression: "!error"
    }],
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Please enter your email and further instructions will be sent to recover your password.")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.error),
      expression: "!error"
    }],
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "placeholder": "Email",
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.error),
      expression: "!error"
    }],
    staticClass: "btn btn-block btn-primary btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Go back to Sign In")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-at"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62ea2efe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ResetPassword.vue
// module id = 655
// module chunks = 0